import React from 'react'
import { Text, SummaryExercise, Heading } from 'components/library'
import pdf from './assets/5c8a1c4bfe36da2d5e24d52d-1555062967775-H3_Bijzonderheden_sleepbewegingen_in_de_praktijk_SLEEP.pdf'

const Intro = props => (
	<div>
		<Text><strong>In dit hoofdstuk leer je:</strong></Text>
		<ul style={{marginTop: '0'}}>
			<li>welke restricties er gelden tijdens de verschillende fasen van beperkt zicht omstandigheden;</li>
			<li>wat je moet doen bij een vooralarm en Vliegtuig Ongeval Schiphol;</li>
			<li>welke regels er gelden voor de bijzondere sleepobjecten;</li>
			<li>wat de regels en procedures zijn op een aantal bijzondere locaties.</li>
		</ul>
	</div>
)

const Summary = props => (
	<div>
		<div>
			<ul style={{marginTop: '0'}}>
				<li>welke restricties er gelden tijdens de verschillende fasen van beperkt zicht omstandigheden;</li>
				<li>wat je moet doen bij een vooralarm en Vliegtuig Ongeval Schiphol;</li>
				<li>welke regels er gelden voor het slepen van een A380 en overige sleepobjecten;</li>
				<li>wat de regels en procedures zijn op het Uniform- Kilo- en Juliett-platform en bij Hangar 4 en 32.</li>
			</ul>
		</div>

		<div>
			<SummaryExercise link={pdf}>
				<Heading h3>Bijzonderheden Sleepbeweging in de praktijk</Heading>
		    <ul style={{marginTop: '0'}}>
		      <li>Neem eens een kijkje op het Kilo-platform. Vraag eens aan je instructeur of jullie samen de security procedure kunnen doorlopen.</li>
		      <li style={{margin: '3rem 0'}}>Ga dan ook meteen eens naar Hangar 4 en 32 toe. Kun je zien waarom er een speciale procedure geldt voor het uitvoeren van sleepbewegingen?</li>
		      <li>Vraag aan je instructeur of jullie naar het Uniform-platform toe kunnen gaan zodat je kunt zien hoe je daar een vliegtuig moet parkeren</li>
					<li style={{marginTop: '3rem'}}>Ga eens langs bij het Juliett-platform en bekijk hoe het de-icingproces in zijn werk gaat.</li>
		    </ul>
			</SummaryExercise>
		</div>
  </div>
)

export { Intro, Summary }



// WEBPACK FOOTER //
// ./src/content/chapters/03/index.js